// extracted by mini-css-extract-plugin
module.exports = {"tip":"Tip_tip__CKHld","image":"Tip_image__lVDNU","blockquote":"Tip_blockquote__MtUXA","header":"Tip_header__rbME6","picture":"Tip_picture__ENofQ","heading":"Tip_heading__iOpIN"};